import { render, staticRenderFns } from "./contribute.vue?vue&type=template&id=a80e1f94&scoped=true"
import script from "./contribute.vue?vue&type=script&lang=js"
export * from "./contribute.vue?vue&type=script&lang=js"
import style0 from "./contribute.vue?vue&type=style&index=0&id=a80e1f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e1f94",
  null
  
)

export default component.exports